export interface GroupPolicyException {
    id: string;
}

export interface GroupItem {
    groupId: string;
    groupName: string | null;
    isActive: boolean;
    memberCount: number;
    createdAt: string | null;
    updatedAt: string | null;
    updatedBy: string | null;
    policyExceptions: GroupPolicyException[];
    policyIds: string[];
}

export interface GroupsSummary {
    totalGroups: number;
    assignedUsers: number;
    unassignedUsers: number;
}

export interface GroupsPageInfo {
    totalCount: number;
    cursor: string | null;
    limit: number;
    hasNextPage: boolean;
}

export interface GroupMemberName {
    firstName: string | null;
    lastName: string | null;
}

export interface GroupMember {
    userId: string;
    emailId: string | null;
    legalName: GroupMemberName | null;
}

export interface GroupApproverUser {
    userId: string;
    emailId: string | null;
    legalName: GroupMemberName | null;
}

export enum GroupApproverMode {
    List = "list",
    Manager = "manager",
    None = "none",
    /** @deprecated Legacy API value — normalized to {@link List} on read */
    Alternate = "alternate",
}

export interface GroupApproverConfig {
    approverMode: GroupApproverMode | null;
    /** Bare user IDs returned by getGroupById — hydrate via groupsUsersByBatch */
    approvers: string[];
    /** Bare user IDs returned by getGroupById — hydrate via groupsUsersByBatch */
    backupApprovers: string[];
}

/** Hydrated user from the groupMembers paginated query (uses legalName) */
export interface GroupMemberUser {
    userId: string;
    emailId: string | null;
    status: string | null;
    legalName: GroupMemberName | null;
}

export interface GroupMembersPageInfo {
    totalCount: number;
    cursor: string | null;
    limit: number;
    hasNextPage: boolean;
}

/** Hydrated user from the groupsUsersByBatch query */
export interface GroupBatchUser {
    userId: string;
    emailId: string | null;
    status: string | null;
    legalName: { firstName: string | null; lastName: string | null } | null;
}

export interface GroupBatchPageInfo {
    limit: number;
    hasMore: boolean;
    nextCursor: string | null;
}

export interface GroupCustomField {
    id: string;
    label: string | null;
}

export interface GroupDetailItem extends GroupItem {
    description: string | null;
    companyId: string | null;
    isDefault: boolean;
    createdBy: string | null;
    /** Bare user IDs — hydrate via groupMembers query */
    members: string[];
    approverConfig: GroupApproverConfig | null;
    notifyEmail: string | null;
    customFields: GroupCustomField[];
    groupEpoch: string | null;
    /** Bare user IDs — hydrate via groupsUsersByBatch */
    accountants: string[];
}
